<template>
  <div class="login" id="loginenid">
    <div id="autosize">
        <div class="title"  style=" position:absolute;text-align:center;width:100%;">

      <div class="img1" style="display:flex;float:left;width:300px;width: 20%;">
         <img class="imgstyle" style="float:left;margin-left:80px;margin-top:80px;" src="/static/images/login/QRCode.jpg">
         <img class="imgstyle" style="float:left;margin-left:40px;margin-top:80px;" src="/static/images/login/QRCode2.jpg">
      </div>

      <div class="txt1" style="display:inline-block;float:right;margin-right:80px;margin-top:80px;height:100%;width: 20%;">

          <span class="help" style="display:block;width:100%;font-size:20px;text-align:right;">
            <a class="lanb" style="font-size:20px;"  href="/static/templates/帮助手册.doc">Help</a>
            <span>|</span>
            <span class="lanb"  style="font-size:20px;" @click="clk()">中文</span>
            <span>|</span>
            <span class="lana" style="font-size:20px;" >English</span>
          </span>
          <a class="lanb" style="font-size:25px;width:100%;display:block;text-align:right;float: right;"
         href="http://www.fireexpo.cn" target="_blank">Back</a>
         <!--
          <span class="lanb" @click="zgclk" style="font-size:25px;width:100%;background:rgba(0,0,0,0.4);display:block;padding:5px;margin-top:5px;margin-bottom:5px;text-align:right;width: 310px;float: right;">View Booth Reservations</span>
        -->  
          <!-- <a class="lanb" style="font-size:25px;width:100%;display:block;text-align:right;float: right;"  href="/static/templates/展馆图片.zip">Download Pavilion Pictures</a>
          -->
      </div>
      <div class="tit" style="display:inline-block;text-align:center;margin-top:6%;margin-left:35px;width: 50%;">
         <span style=" display:inline-block;text-align:center;">
          <img style = "display:inline-block;height:80px;width:80px; vertical-align:middle;" src="/static/images/login/logo.png">
          <span id="txta" style="font-size:50px;color:#fff;font-weight:bold;display:inline-block; vertical-align:middle;">CHINA FIRE</span>
        </span>
          <span id="txtb" style="font-size:50px;color:#fff;font-weight:bold;display:block;text-align:center;margin-left:35px">China Fire 2025 Exhibition System</span>
      </div>
    </div>
    </div>
  <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "Login",
  data() {
    return {
    };
  },
  mounted: function() {
    let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    //获取htmlDom
    let htmlDom = document.getElementsByTagName('html')[0];
    //设置html的font-size
    htmlDom.style.fontSize = htmlWidth / 120 + 'px';
    window.addEventListener('resize', (e) => {
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      //获取htmlDom
      let htmlDom = document.getElementsByTagName('html')[0];
      //设置html的font-size
      htmlDom.style.fontSize = htmlWidth / 120 + 'px';
    })
    this.init()
  },
  methods: {

    clk(){
      this.$router.push({ path: '/exhibition/login/ch/Login' });
    },
    zgclk(){
      this.$router.push({ path: '/plan/planAnonEN' });
    },
   //适配屏幕分辨率
   init(){
       //判断是否宽屏
       var winWide = window.screen.availWidth;

       if(winWide < 1400){
         document.getElementById("txta").style.fontSize = "35px";
         document.getElementById("txtb").style.fontSize = "35px";
       }else{
         document.getElementById("txta").style.fontSize = "50px";
         document.getElementById("txtb").style.fontSize = "50px";
       }
   },

  }
};
</script>

<style lang="scss" scoped >
@import '@/common/scss/login.scss';


// 右侧中英文切换样式
.market_out{
  width: 500px;
  .el-tabs__item{
    color:red;
  }
}

.lana {
  color: $blackcolor;
}
.lanb {
  color: $whitecolor;
}

.footer {

  margin-top: 1.5rem;
  p{
    margin: 0px;
    padding:0px;
    height: 1.8rem;
  }
  text-align: center;
  color: $whitecolor;
  font-size: 0.7rem;
  * {
    text-align: center;
    color: $whitecolor;
    font-size: 0.7rem;
  }
}

.footerstyle p{
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/views/common/LoginEN.vue